import { useState, useEffect } from 'react'

import { Loader } from '../../common/components/loader'
import { TextInput } from '../../common/components/text-input'
import { Button } from '../../common/components/button'
import { ReportTemplateHeader } from '../templates/report-template-header'
import { httpService } from '../../common/services/http.service'
import { contentService } from '../../common/services/content.service'
import { router } from '../../common/contexts/routerContext'
import NotificationManager from '../../common/components/Notifications/NotificationManager'

import { useStyles } from './iframe-subfolder-report.style'

const SUBFOLDER_PARAM_NAME = 'sf'

// We will need to move these into the report data model if we need different messaging in the future
const SUBFOLDER_PROMPT = 'Please enter your site identifier below to see a custom report for your site.'
const SUBFOLDER_NOT_EXIST_ERROR = 'Site identifier was not found. Try again?'

export const IframeSubfolderReport = function ({ report, fullHeight = false }) {
  const classes = useStyles()

  const subfolder = router.getQueryParam(SUBFOLDER_PARAM_NAME)

  const [subfolderInput, setSubfolderInput] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // Prefill subfolder if already navigated to a subfolder previously
    const subfolderStorage = getSubfolderStored(report.id)
    if (subfolderStorage) {
      setSubfolderInput(subfolderStorage)
    }

    // When navigating to a subfolder, store subfolder for later
    if (subfolder) {
      setSubfolderStored(report.id, subfolder)
    }
  }, [])

  const containerIndexUrl = getContainerIndexUrl(report.containerId, subfolder)

  function handleSubfolderInputChange (event) {
    setSubfolderInput(event.target.value)
  }

  async function goToSubfolder () {
    setLoading(true)
    const containerIndexUrl = getContainerIndexUrl(report.containerId, subfolderInput)
    const subfolderExists = await httpService.checkResourceExists(containerIndexUrl)

    if (subfolderExists) {
      router.replaceQueryParams({ [SUBFOLDER_PARAM_NAME]: subfolderInput })
    } else {
      NotificationManager.create({ type: 'error', timeOut: 20000, message: SUBFOLDER_NOT_EXIST_ERROR })
      setLoading(false)
    }
  }

  function getContainerIndexUrl (containerId, subfolder) {
    return (containerId && subfolder)
      ? contentService.getUrl(containerId, `${subfolder}/index.html`)
      : ''
  }

  if (loading) return <Loader />

  return containerIndexUrl
    ? (
      <iframe src={containerIndexUrl} className={fullHeight ? classes.iframeFullHeight : classes.iframe} frameBorder="0" />
    )
    : (<div className="flex-column flex-auto">
      <div><ReportTemplateHeader report={report} /></div>
      <div className={classes.subfolderInputSection}>
        <div className="input-prompt">{SUBFOLDER_PROMPT}</div>
        <form onSubmit={goToSubfolder}>
          <div className="flex-row flex-center-items">
            <TextInput
              data-qa="subfolder-input"
              onChange={handleSubfolderInputChange}
              value={subfolderInput}
              autoFocus={true}
            />
            <Button
              type="submit"
              className={classes.viewSubfolderButton}
              data-qa="view-subfolder-button"
              disabled={subfolderInput.length === 0}
            >
              View
            </Button>
          </div>
        </form>
      </div>
    </div>
    )
}

function getSubfolderStored (id) {
  return localStorage.getItem(`${id}-${SUBFOLDER_PARAM_NAME}`)
}

function setSubfolderStored (id, value) {
  localStorage.setItem(`${id}-${SUBFOLDER_PARAM_NAME}`, value)
}
